import { render, staticRenderFns } from "./ProposalGridCard.vue?vue&type=template&id=48779ada"
import script from "./ProposalGridCard.vue?vue&type=script&lang=js"
export * from "./ProposalGridCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports